'use es6';

export const QUOTA_DATE_PROPERTY = 'hs_period_start_date';
export const QUOTA_OWNER_PROPERTY = 'hubspot_owner_id';
export const QUOTA_PIPELINE_PROPERTY = 'hs_pipeline_id';
export const QUOTA_TYPE_PROPERTY = 'hs_quota_type';
export const QUOTA_VALUE_PROPERTY = 'hs_value';
export const QUOTA_NAMESPACE = 'QUOTAS';